namespace GeniuzPOS.Purchase {
    export interface ListAppPurOrderRow {
        SendForAppfg?: sendapp;
        WaitLv?: number;
        WaitApprove?: string;
        SysDocNo?: string;
        PoTypeFg?: POTypeFg;
        SupplierId?: string;
        NetTotalInVat?: number;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        LastApprove?: string;
        ApproveDate?: string;
        ShipId?: string;
        Remark?: string;
    }

    export namespace ListAppPurOrderRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'WaitApprove';
        export const localTextPrefix = 'Purchase.ListAppPurOrder';
        export const lookupKey = 'Purchase.ListAppPurOrder';

        export function getLookup(): Q.Lookup<ListAppPurOrderRow> {
            return Q.getLookup<ListAppPurOrderRow>('Purchase.ListAppPurOrder');
        }
        export const deletePermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:Modify';
        export const insertPermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:Modify';
        export const readPermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';
        export const updatePermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:Modify';

        export declare const enum Fields {
            SendForAppfg = "SendForAppfg",
            WaitLv = "WaitLv",
            WaitApprove = "WaitApprove",
            SysDocNo = "SysDocNo",
            PoTypeFg = "PoTypeFg",
            SupplierId = "SupplierId",
            NetTotalInVat = "NetTotalInVat",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            LastApprove = "LastApprove",
            ApproveDate = "ApproveDate",
            ShipId = "ShipId",
            Remark = "Remark"
        }
    }
}
